<template>
    <el-dialog
        title="编辑"
        :visible.sync="visible"
        width="30%"
        :close-on-click-modal="false"
        :before-close="handleClose">
        <el-form ref="form" :model="form" :rules="rules" label-width="90px">
            <el-form-item label="是否有意向" prop="isIntention">
                <m-select
                    :value="form.isIntention"
                    :optionNum="'SRM_YES_NO'"
                    @input="propsChange"
                ></m-select>
            </el-form-item>
            <el-form-item label="意向线路" prop="intentionLine" v-if="isIntentionValidate(SRM_YES)" key="intentionLine">
                <el-input v-model.trim="form.intentionLine"></el-input>
            </el-form-item>
            <el-form-item label="无意向原因" prop="noIntentionReason" v-if="isIntentionValidate(SRM_NO)" key="noIntentionReason">
                <el-input v-model.trim="form.noIntentionReason"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" :loading="saveLoading" @click="handleSave">保 存</el-button>
        </span>
    </el-dialog>
</template>
<script>
import mSelect from '@/components/lots/otpSelect2/index';
import { SRM_YES, SRM_NO } from '../../../constant/constant.js';
import { updateRecord } from '../../../api/supplierBid.js';

export default {
    components: { mSelect },
    data() {
        return {
            visible: false,
            currentRow: null,
            saveLoading: false,
            SRM_YES,
            SRM_NO,
            form: {
                isIntention: '',
                intentionLine: '',
                noIntentionReason: '',
            },
            rules: {
                isIntention: [{ required: true, message: '请选择是否有意向', trigger: ['blur', 'change'] }],
                intentionLine: [
                    { required: true, message: '请输入意向线路', trigger: ['blur', 'change'] },
                    { max: 64, message: '字符长度不能超过64位!', trigger: ['blur', 'change'] }
                ],
                noIntentionReason: [
                    { required: true, message: '请输入无意向原因', trigger: ['blur', 'change'] },
                    { max: 64, message: '字符长度不能超过64位!', trigger: ['blur', 'change'] }
                ],
            },
        };
    },
    methods: {
        handleClose() {
            this.visible = false;
            this.$refs.form.resetFields();
            this.currentRow = null;
        },
        open(row) {
            this.visible = true;
            this.currentRow = row;
            this.form = {
                isIntention: row.isIntention,
                intentionLine: row.intentionLine,
                noIntentionReason: row.noIntentionReason,
            };
        },
        propsChange(val) {
            this.form.isIntention = val;
            this.form.intentionLine = '';
            this.form.noIntentionReason = '';
        },
        isIntentionValidate(flag) {
            let itemShow = false;
            if (![null, undefined, ''].includes(this.form.isIntention)) {
                itemShow = +this.form.isIntention === +flag;
            }
            return itemShow;
        },
        handleSave() {
            this.$refs.form.validate().then(valid => {
                this.saveLoading = true;
                const params = {
                    ...this.currentRow,
                    ...this.form
                };
                updateRecord(params).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('编辑已保存!');
                        this.handleClose();
                        this.$emit('save');
                    }
                }).finally(() => { this.saveLoading = false; })
            }).catch(() => {});
        }
    }
};
</script>